var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"rule_title"},[_vm._v("通用逻辑")]),_c('div',{staticClass:"rule_item"},[_vm._v("1. 新表单：按照分配规则分配，凌晨按新一天的规则分配前一天未分配出去的表单")]),_c('div',{staticClass:"rule_item"},[_vm._v("2. 重复表单： 不做分配，做重复表单提醒")])])
}]

export { render, staticRenderFns }